import { Component, Input } from '@angular/core';
import { FieldBase } from '../field.base';
import { UntypedFormGroup } from '@angular/forms';
import { FormField } from '../../../../../../api/models/form-field';

@Component({
    selector: 'otb-email-field',
    templateUrl: './email-field.component.html',
    styleUrls: ['./email-field.component.scss'],
    standalone: false,
})
export class EmailFieldComponent extends FieldBase {
    @Input() formField: FormField;
    @Input() form: UntypedFormGroup;

    @Input() formNumber: number = 0;
}
